import React from 'react';

import Icon from 'components/Icon/Icon';
import {setAllBeersFilterAC, setAllBeersAC} from 'features/beersManager/slice';
import {useGlobalState} from 'hooks/useGlobalState';
import useOnClickOutside from 'hooks/useOnClickOutside';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {debounce} from 'lodash';
import {GetBeersDTO} from 'typescript/dto/beersDto';

import {BeerDropdown} from '../BeerDropdown';

interface IProps {
  setIsInputFocused: React.Dispatch<React.SetStateAction<boolean>>;
  allBeerFilter: GetBeersDTO;
  isInputFocused: boolean;
}

export const BeersPubHeader = (props: IProps) => {
  const {allBeerFilter, isInputFocused, setIsInputFocused} = props;
  const dispatch = useSetGlobalState();

  const {allBeers, beerTotalPages} = useGlobalState((state) => state.beersManager);

  const {containerRef} = useOnClickOutside<HTMLDivElement>(() => {
    setIsInputFocused(false);
  });

  const handleSearch = debounce((value: string) => {
    if (!value && allBeers.length) dispatch(setAllBeersAC([]));
    dispatch(setAllBeersFilterAC({...allBeerFilter, name: value, page: 1}));
  }, 500);

  const getNextPageItems = (page: number) => {
    if (beerTotalPages === page) return;

    dispatch(setAllBeersFilterAC({...allBeerFilter, page: page + 1}));
  };

  return (
    <div className="list-beers__header">
      <div
        className={`list-beers__items-container ${isInputFocused ? 'list-beers__items-container--open' : ''}`}
        ref={containerRef}
      >
        <div className="search">
          <input
            onClick={() => setIsInputFocused((state) => !state)}
            className="search__field"
            placeholder="Start typing or select beers..."
            onChange={(e) => handleSearch(e.target.value)}
          />
          <button onClick={() => setIsInputFocused((state) => !state)}>
            <Icon icon="chevron-down" />
          </button>
        </div>
        {isInputFocused && (
          <BeerDropdown
            className="list-beers__items"
            getNextPageItems={getNextPageItems}
            beersDropdownPage={allBeerFilter.page}
            beerTotalPages={beerTotalPages}
            allBeers={allBeers}
            search={allBeerFilter.name}
          />
        )}
      </div>
    </div>
  );
};
